import React from 'react';
import { DefaultTheme, ThemeProvider } from '@react-navigation/native';
import { Stack } from 'expo-router';
import { theme } from '@sg/garnish';

import { useModalScreenOptions } from './hooks';
import { DEFAULT_SCREEN_OPTIONS } from './options';

// ─────────────────────────────────────────────────────────────────────────────

export default function RootLayout() {
  const modalScreenOptions = useModalScreenOptions();

  return (
    <ThemeProvider value={NAVIGATION_THEME}>
      <Stack initialRouteName="(tabs)" screenOptions={SCREEN_OPTIONS}>
        <Stack.Screen name="(auth)" options={{ presentation: 'modal' }} />
        <Stack.Screen name="(modals)" options={modalScreenOptions} />
      </Stack>
    </ThemeProvider>
  );
}

// ─── Constants ───────────────────────────────────────────────────────────────

/**
 * `@react-navigation/elements` v2 expects `fonts` in the theme, but
 * `@react-navigation/native` v6's `DefaultTheme` does not include it.
 *
 * We extend the default theme with `fonts` to prevent crashes in
 * components like `HeaderTitle` that access `theme.fonts.bold`.
 */
const NAVIGATION_THEME = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: theme.colors.APP_BACKGROUND,
  },
  fonts: {
    regular: { fontFamily: 'SweetSans Text', fontWeight: '400' as const },
    medium: { fontFamily: 'SweetSans Text', fontWeight: '500' as const },
    bold: { fontFamily: 'SweetSans Text', fontWeight: '700' as const },
    heavy: { fontFamily: 'SweetSans Text', fontWeight: '900' as const },
  },
};

const SCREEN_OPTIONS = {
  ...DEFAULT_SCREEN_OPTIONS,
  title: 'sweetgreen',
};
